/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ExternalServiceType } from './ExternalServiceType.js';
import {
    ExternalServiceTypeFromJSON,
    ExternalServiceTypeFromJSONTyped,
    ExternalServiceTypeToJSON,
} from './ExternalServiceType.js';

/**
 * 
 * @export
 * @interface ExternalServiceConfig
 */
export interface ExternalServiceConfig {
    /**
     * 
     * @type {number}
     * @memberof ExternalServiceConfig
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalServiceConfig
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalServiceConfig
     */
    description?: string;
    /**
     * 
     * @type {ExternalServiceType}
     * @memberof ExternalServiceConfig
     */
    type?: ExternalServiceType;
    /**
     * 
     * @type {any}
     * @memberof ExternalServiceConfig
     */
    options?: any;
}

/**
 * Check if a given object implements the ExternalServiceConfig interface.
 */
export function instanceOfExternalServiceConfig(value: object): boolean {
    return true;
}

export function ExternalServiceConfigFromJSON(json: any): ExternalServiceConfig {
    return ExternalServiceConfigFromJSONTyped(json, false);
}

export function ExternalServiceConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalServiceConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'type': json['type'] == null ? undefined : ExternalServiceTypeFromJSON(json['type']),
        'options': json['options'] == null ? undefined : json['options'],
    };
}

export function ExternalServiceConfigToJSON(value?: ExternalServiceConfig | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'type': ExternalServiceTypeToJSON(value['type']),
        'options': value['options'],
    };
}

